import Vue from "vue";
import Router from "vue-router";
const MainClient = () => import("@/views/layout/mainClient"); //主框架
//新增页面

const pay = () => import("@/views/new_pay/pay");
const packagePurchase = () => import("@/views/userCenter/purchase/purchase");
const extractAPI = () => import("@/views/userCenter/apiAcquisition/apiAcquisition");
const applay = () => import("@/views/applay/applay"); //支付跳转页
//用户中心
const authentication = () => import("@/views/authentication/index"); //支付跳转页

const channelManagement = () => import("@/views/userCenter/channelManagement"); // 通道管理-主页
const channelPlusManagement = () =>
  import("@/views/userCenter/channelManagementPlus"); // 通道管理-主页
const bandwidthTunnel = () => import("@/views/userCenter/bandwidthTunnel"); // 带宽隧道
const staticProxy = () => import("@/views/userCenter/staticProxy"); // 静态住宅代理
const staticProxyDetails = () =>
  import("@/views/userCenter/staticProxy/consumerDetails"); // 静态-详情
const staticResidentialIpList = () => import("@/views/userCenter/staticResidentialIpList"); // 静态住宅IP列表
const bandwidthExtractAPI = () =>
  import("@/views/userCenter/bandwidthTunnel/extractAPI"); // 带宽隧道 - 提取api
const bandwidthAccountPassword = () =>
  import("@/views/userCenter/bandwidthTunnel/accountPassword"); // 带宽隧道 - 账密认证

const consumerDetails = () =>
  import("@/views/userCenter/channelManagement/consumerDetails"); // 通道管理-消费明细
const accountInfo = () => import("@/views/userCenter/accountInfo"); //账户信息
const flowOrder = () => import("@/views/userCenter/flowOrder"); // 流量订单
const goldCoinOrder = () => import("@/views/userCenter/goldCoinOrder"); // 金币订单
const withdraw = () => import("@/views/userCenter/withdraw"); //提现记录
const cashback = () => import("@/views/userCenter/cashback"); //返现统计
const invitationCode = () => import("@/views/userCenter/invitationCode/index"); //邀请统计
const certification = () => import("@/views/userCenter/certification"); //实名认证
const login = () => import("@/views/login/index"); //实名认证
const orderList = () => import("@/views/userCenter/order/index"); //实名认证
const accountMannage = () => import("@/views/userCenter/accountMannage/index"); //实名认证

const lumiWallet = () => import("@/views/userCenter/lumiWallet"); // lumi钱包



Vue.use(Router);

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: "history",
  routes: [
    {
      path: "/MainClient",
      name: "MainClient",
      component: MainClient,
      children: [
        {
          path: "/pay",
          name: "pay",
          component: pay,
          meta: "lumidaili-购买"
        },
        {
          path: "/MainClient/extractAPI",
          name: "extractAPI",
          component: extractAPI,
          meta: {
            title: "lumidaili-API获取"
          }
        },
        {
          path: "/MainClient/channelManagement",
          name: "channelManagement",
          component: channelManagement,
          meta: {
            title: "基础流量隧道-纯净高质量代理IP提供商" //原通道管理
          }
        },
        {
          path: "/MainClient/channelPlusManagement",
          name: "channelPlusManagement",
          component: channelPlusManagement,
          meta: {
            title: "PLUS流量隧道-纯净高质量代理IP提供商" //原通道管理
          }
        },
        {
          path: "/MainClient/bandwidthTunnel",
          name: "bandwidthTunnel",
          component: bandwidthTunnel,
          meta: {
            title: "包月订单-纯净高质量代理IP提供商" //带宽隧道
          }
        },{
          path:"/MainClient/staticProxy",
          name: "staticProxy",
          component: staticProxy,
          meta: {
            title: "静态住宅-纯净高质量代理IP提供商" //静态
          }
        },{
          path:"/MainClient/staticResidentialIpList",
          name: "staticResidentialIpList",
          component: staticResidentialIpList,
          meta: {
            title: "静态住宅IP列表-纯净高质量代理IP提供商" //静态
          }
        },
        {
          path:'/MainClient/staticProxyDetails',
          name: "staticProxyDetails",
          component: staticProxyDetails,
          meta: {
            title: "订单信息-纯净高质量代理IP提供商" //静态
          }
        },
        {
          path: "/MainClient/bandwidthExtractAPI",
          name: "bandwidthExtractAPI",
          component: bandwidthExtractAPI,
          meta: {
            title: "包月订单提取API-纯净高质量代理IP提供商" //带宽隧道
          }
        },
        ,
        {
          path: "/MainClient/bandwidthAccountPassword",
          name: "bandwidthAccountPassword",
          component: bandwidthAccountPassword,
          meta: {
            title: "包月订单账密认证-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/packagePurchase",
          name: "packagePurchase",
          component: packagePurchase,
          meta: {
            title: "产品购买-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/consumerDetails",
          name: "consumerDetails",
          component: consumerDetails,
          meta: {
            title: "消费明细-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/accountInfo",
          name: "accountInfo",
          component: accountInfo,
          meta: {
            title: "概览-纯净高质量代理IP提供商"
          }
        },{
          path: "/MainClient/accountMannage",
          name: "accountMannage",
          component: accountMannage,
          meta: {
            title: "账户管理-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/flowOrder",
          name: "flowOrder",
          component: flowOrder,
          meta: {
            title: "流量订单-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/applay",
          name: "applay",
          component: applay,
          meta: {
            title: ""
          }
        },{
          path:'/authentication',
          name: "authentication",
          component: authentication,
          meta: {
            title: ""
          }
        },
        {
          path: "/MainClient/goldCoinOrder",
          name: "goldCoinOrder",
          component: goldCoinOrder,
          meta: {
            title: "金币订单-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/invitationCode",
          name: "invitationCode",
          component: invitationCode,
          meta: {
            title: "邀请码-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/withdraw",
          name: "withdraw",
          component: withdraw,
          meta: {
            title: "提现记录-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/cashback",
          name: "cashback",
          component: cashback,
          meta: {
            title: "返现记录-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/certification",
          name: "certification",
          component: certification,
          meta: {
            title: "实名认证-纯净高质量代理IP提供商"
          }
        },
        {
          path: "/MainClient/orderList",
          name: "orderList",
          component: orderList,
          meta: {
            title: "我的订单-纯净高质量代理IP提供商"
          }
        },{
          path: "/MainClient/lumiWallet",
          name: "lumiWallet",
          component: lumiWallet,
          meta: {
            title: "lumi钱包-纯净高质量代理IP提供商"
          }
        },{
          path: "/login",
          name: "login",
          component: login,
          meta: {
            title: "lumidaili"
          }
        },
      ]
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "*",
      redirect: "/login"
    }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js